/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as r from "react";
import t from "prop-types";
import { IconWrap as c } from "@progress/kendo-react-common";
import { chevronLeftIcon as o, chevronRightIcon as d } from "@progress/kendo-svg-icons";
const m = r.forwardRef(
  (e, l) => {
    const n = r.useRef(null), i = r.useRef(null);
    return r.useImperativeHandle(n, () => {
      var a;
      return {
        element: ((a = i.current) == null ? void 0 : a.element) || null,
        props: e
      };
    }), r.useImperativeHandle(
      l,
      () => n.current
    ), /* @__PURE__ */ r.createElement(
      c,
      {
        ref: i,
        id: e.id,
        "aria-hidden": !0,
        tabIndex: e.tabIndex,
        style: e.style,
        name: e.dir === "rtl" ? "chevron-left" : "chevron-right",
        icon: e.dir === "rtl" ? o : d,
        className: "k-breadcrumb-delimiter-icon",
        size: "xsmall"
      }
    );
  }
), s = {
  id: t.string,
  className: t.string,
  style: t.object,
  tabIndex: t.number,
  dir: t.string
};
m.displayName = "KendoReactBreadcrumbDelimiter";
m.propTypes = s;
export {
  m as BreadcrumbDelimiter
};
